'use client';

export { default } from './Switch';
export { default as switchClasses } from './switchClasses';
export * from './switchClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Switch/index.js
// module id = 335
// module chunks = 25